





















































































































































import { ref, computed, defineComponent, onMounted, watch } from '@vue/composition-api';
import ChartsCard from '../charts-card.vue';
import ChartsLine from '../charts-line.vue';
import IconText from '../iconText.vue';
import SelectNav from '../select-nav.vue';
import ModuleTitle from '../module-title.vue';
import MapTable from '../map-table.vue';
import throttle from 'lodash/throttle';
import { createFilterForm, filterSetting } from '../../filter';
import { handleErrorMessageToast, handleWarningMessageToast } from '@/common/util';
import { useIncomeData } from '../../hooks/income-data';
import { ChartsType, ChartType, SelectorsType } from '../../types'
export default defineComponent({
    name: "income-iaa", // ICP备案主页面
    components: {
        IconText,
        ModuleTitle,
        ChartsCard,
        ChartsLine,
        SelectNav,
        MapTable,
    },

    props: {
        tabActive: {
            type: String,
            default: ''
        },
        appId: {
            type: String,
            required: true
        },
        gameType: {
            type: String,
            required: true,
            // default: 'iaa'
        }
    },
    setup(props, context) {
        const {
            offset,
            getCorePannelLineChart,
            corePannelLineChartData,
            newCardConfig,
            fillterForm,
            selectList,
            cardData,
            getCardChart,
            dashboardData,
            getBatchChart,
            newDetailChartsData,
            newDetailChartsConfig,
            getTableChart,
            iaaTableData,
            iapTableData,
            tableDownload,
            getDashboard,
            downLoading,
            activeArray,
        } = useIncomeData(props, context)
        const chartsComponents = ref(null) as any;
        // 当前默认展示的表格类型，只有iap类型时默认展示iap表格，其他类型默认都展示iaa表格。因为iaap类型是两个表格，且默认展示iaa表格
        const tableType = ref<string>(props.gameType === 'iap' ? 'iap' : 'iaa');
        const allLoading = ref(false);

        // 当前展示的table 数据是否已经准备好，没有不展示下载按钮
        const tableDataOK = computed(() => {
            const tableData = tableType.value === 'iaa' ? iaaTableData.value! : iapTableData.value!;
            return !!tableData;
        })

        // 根据当前config 找到configItem对应的data
        function findChartItemData(configItem: ChartsType) {
            return newDetailChartsData.value.find((val: ChartType) => val && val.chartId === configItem.chartId);
        }

        // 获取指标详情-chart的补充文案
        function subText(configItem: ChartsType) {
            return filterSetting(configItem.chartSetting).subText || '';
        }

        // 获取chartSetting里 获取是否展示为整数的配置
        function showInteger(configItem: ChartsType) {
            return filterSetting(configItem.chartSetting).showInteger || false;
        }

        // 表格-切换tab
        function changeTableButton(value: string) {
            // 如果切换tab，目标tab有值的话，return; 如果目标tab无值，请求接口
            if((value === 'iaa' && iaaTableData.value) || (value === 'iap' && iapTableData.value)) return;
            getTableChart(value)
        }

        // 点击重置
        function clicRest() {
            const conditions = dashboardData.value.conditions
            fillterForm.value = createFilterForm(conditions, props.appId);
        }

        // 点击每个卡片控制下方折线展示
        function clickCard(item: SelectorsType) {
            chartsComponents.value.changeLegend(item.fieldName);
        }

        // 下载表格
        function clickTableDown() {
            if(downLoading.value) {
                handleWarningMessageToast('正在下载表格中...');
                return;
            }
            tableDownload(tableType.value);
        }

        // 防止连续点击
        const clickTableDownThrottle = throttle(clickTableDown, 1000, { 'trailing': false })

        // 滚动到指定位置
        function scrollPos(id: string) {
            const ele = document.getElementById(id);
            if (!ele) return;
            window.scrollTo({ top: ele.offsetTop - 20, behavior: 'smooth' });
        }

        // 筛选条件变化时清空当前页面所有数据
        function clearAllChartData() {
            // card默认选中项初始化（全都选中）
            activeArray.value = newCardConfig.value!.selectors.map((item: SelectorsType) => item.fieldName)
            // 批量请求的初始坐标为0
            offset.value = 0;
            cardData.value = [];
            corePannelLineChartData.value = null;
            newDetailChartsData.value = [];
            iaaTableData.value = null;
            iapTableData.value = null
        }

        // 页面初始化
        async function init() {
            // 接口请求顺序 1、incomeData.ts 里的 getDashboard，getDashboard返回查询条件后才会触发watch，init()在watch内
            allLoading.value = true;
            Promise.all([
                // 清空当前页面所有数据
                clearAllChartData(),
                // 获取核心数据概览——card
                getCardChart(),
                // 获取核心概览-折现图chart
                getCorePannelLineChart(),
                // 批量获取指标详情里的折线图  先请求4个，4个返回后再继续请求，依次类推
                await getBatchChart(),
                // 获取初始表格chart
                getTableChart(tableType.value)
            ]).finally(() => {
                allLoading.value = false;
                context.emit('loadOver', allLoading.value);
                console.log('所有接口请求完毕')
            })
        }

        watch(
            () => fillterForm.value,
            (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                // 页面初始化 之前还会请求 getDashboard，getDashboard返回筛选条件后才会触发watch
                init();
            },
            {
                deep: true
            }
        );
        watch(
            () => props.appId,
            async (val) => {
                if(allLoading.value) {
                    handleWarningMessageToast('操作太频繁了，请等一等数据~')
                    return;
                }
                tableType.value = props.gameType === 'iap' ? 'iap' : 'iaa'
                // 重新请求dashbord，会重置所有筛选条件，触发上方的watch
                getDashboard()
            }
        );


        return {
            showInteger,
            activeArray,
            downLoading,
            allLoading,
            scrollPos,
            tableDataOK,
            clickTableDownThrottle,
            iapTableData,
            iaaTableData,
            findChartItemData,
            newDetailChartsConfig,
            clicRest,
            newCardConfig,
            chartsComponents,
            fillterForm,
            selectList,
            cardData,
            newDetailChartsData,
            tableType,
            corePannelLineChartData,
            clickCard,
            changeTableButton,
            subText
        }
    },
})
